import type { FirebaseWebPublicConfig } from './environment.types';

/**
 * Public Firebase Web SDK config (same project as native `GoogleService-Info.plist` / `google-services.json`).
 * Safe to ship in the client bundle; restrict usage in Firebase Console (API keys, authorized domains).
 */
export const cleannoFirebaseWebConfig: FirebaseWebPublicConfig = {
  apiKey: 'AIzaSyDpvJ8srYl-_3liFWth9D9dZAnSWZMKmJE',
  authDomain: 'cleanno-54151.firebaseapp.com',
  projectId: 'cleanno-54151',
  storageBucket: 'cleanno-54151.firebasestorage.app',
  messagingSenderId: '399288076879',
  appId: '1:399288076879:web:a91ac034e25cdc08b3783a',
  measurementId: 'G-Q4P658VXRM',
  webPushVapidKey:
    'BAfjDhRTc4NXLB3ND_6ApP4TlbfZ1lJP-y8X31zESBFidKpa3z6r3KiRtIIVl0r99CYUaoZtjQJtbXJZiT-0k7A',
};
